/*
 * @Author: wyh
 * @Date: 2019-07-29 14:24:52
 * @Last Modified by: wyh
 * @Last Modified time: 2019-08-15 17:04:20
 * @Description: 消息通知服务
 */

import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import { LocalNotifications } from "@ionic-native/local-notifications";
import {
  StorageService,
  EventService,
  RequestService,
  GlobalState,
} from "../../common";
import { INVARIANT } from "../../../config";
import { BackgroundMode } from "@ionic-native/background-mode";

@Injectable()
export class NewsService {
  constructor(
    private localNotifications: LocalNotifications,
    private storageSer: StorageService,
    private eventSer: EventService,
    private requestSer: RequestService,
    private global: GlobalState,
    private backgroundMode: BackgroundMode,
  ) {}

  /**
   * 获取消息列表
   * @param data
   */
  getNewsList(params): Observable<any> {
    return Observable.create((observe) => {
      this.requestSer.httpRequest("ALLMESSAGE_LIST", params).subscribe(
        (res) => {
          const { datas = {}, code } = res;
          if (code != "200") return observe.error(res);
          observe.next(res);
          observe.complete();
        },
        (error) => {
          observe.error(error);
        },
      );
    });
  }

  startTimeer() {
    this.storageSer
      .getStore(INVARIANT._SYS_LOCAL_NOTIFICATION_SUPPORT_PERMISSION)
      .then((res) => {
        if (!res) return;
        this.backgroundMode.enable(); //启用后台运行
        if (this.global.state.notificationTimmer) this.stopTimer();
        const newTimmer = setInterval(() => {
          console.log("push-start");
          this.requestSer
            .httpRequest("GET_LOCAL_NOTIFICATIONS", "", false)
            .subscribe(
              (res) => {
                const { datas = {}, code } = res;
                if (code == "200") {
                  const { handleCount, notifications = [] } = datas;
                  console.log(handleCount);
                  this.eventSer.badgeEvSet(handleCount);
                  const notiArr = [];
                  notifications.forEach((noti) => {
                    const { id, title, text, params, url } = noti;
                    const newID = id + new Date().getTime();
                    notiArr.push({
                      id: newID,
                      title: title,
                      text: text,
                      data: {
                        url: url,
                        params: params,
                      },
                      foreground: true,
                    });
                  });
                  console.log(notiArr);
                  this.localNotifications.schedule(notiArr);
                }
              },
              (err) => {
                this.stopTimer();
              },
            );
        }, INVARIANT._LOCAL_NOTIFICAL_INTIVAL);
        this.global.set("notificationTimmer", newTimmer);
        // setTimeout(() => {
        //     const activeVC = this.app.getActiveNav();
        //     const activeVCname = activeVC.getActive().name;
        //     const url = "NewsPage"
        //     if (activeVCname == "AuthLoginPage") {
        //         this.eventSer.events.publish("test_localNotification", { url: url, params: {} });
        //     } else {
        //         this.RouterSer.forward(url, {});
        //     };
        // }, 60000);
      });
  }

  stopTimer() {
    clearInterval(this.global.state.notificationTimmer);
    this.global.set("notificationTimmer", undefined);
  }

  /**
   * 获取单个消息组消息列表
   * @param params
   */
  getNewsGroupList(params): Observable<any> {
    return Observable.create((observe) => {
      this.requestSer.httpRequest("ALLMESSAGE_GROUP_LIST", params).subscribe(
        (res) => {
          const { code } = res;
          if (code != "200") return observe.error(res);
          observe.next(res);
        },
        (error) => {
          observe.error(error);
        },
      );
    });
  }

  errorHandle(e) {
    return this.requestSer.errorHandle(e);
  }
}



// WEBPACK FOOTER //
// ./src/services/business/news/news.service.ts